import { YM_ID } from "stores/main";

export const sendMetriks = (type, value) => {
  window.ym(Number(YM_ID), type, value);
};